import gsap from 'gsap';

export const PXProcess = (function () {
	'use strict';

	let $arrow, $arrowSVG;

	function init() {
		$arrow = $('.arrow');
		$arrowSVG = $(
			'<svg width="18px" height="12px" viewBox="0 0 18 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Arrow</title> <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round"> <g transform="translate(-189.000000, -3530.000000)" id="Arrow" stroke="#4C54F1" stroke-width="2.5"> <g transform="translate(189.000000, 3531.000000)"> <line x1="0" y1="4.58333333" x2="16" y2="4.58333333" id="Stroke-1"></line> <polyline id="Stroke-3" points="9.74117647 0 16 5.00052737 9.74117647 10"></polyline> </g> </g> </g></svg>'
		);
		$arrow.append($arrowSVG);

		document.querySelectorAll('.process-steps').forEach((processStepsEl) => {
			const steps = processStepsEl.querySelectorAll('.step');
			const dottedLinePaths = processStepsEl.querySelectorAll('.process-steps__dotted-line path');

			if (dottedLinePaths.length > 0) {
				const dottedLineAnimation = gsap.fromTo(
					dottedLinePaths,
					{
						opacity: 0,
					},
					{
						opacity: 1,
						stagger: 0.05,
						paused: true,
					}
				);
			}

			const stepsAnimation = gsap.fromTo(
				steps,
				{
					opacity: 0,
					x: function (index, target, targets) {
						return index % 2 === 0 ? -100 : 100;
					},
				},
				{
					x: 0,
					opacity: 1,
					stagger: 0.25,
					paused: true,
				}
			);

			const io = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							if (dottedLinePaths.length > 0) dottedLineAnimation.play();
							stepsAnimation.play();
						}
					});
				},
				{ rootMargin: '0px 0px -300px 0px' }
			);

			io.observe(processStepsEl);
		});
	}

	return {
		init: init,
	};
})();
